export type DataLayerEvent = Record<string, unknown> & {
  event: string;
};

declare global {
  interface Window {
    dataLayer?: DataLayerEvent[];
  }
}

export const pushDataLayerEvent = (payload: DataLayerEvent): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};
